howspace.widgets.image = (() => {
    'use strict';

    const preventDefaultFn = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const startAnnotating = (widget) => {
        // disable opening a link when clicking on the image
        widget.find('a:has(>.howspace-picture)').on('click', preventDefaultFn);
    };

    const stopAnnotating = (widget) => {
        // enable opening a link when clicking on the image
        widget.find('a:has(>.howspace-picture)').off('click', preventDefaultFn);
    };

    return {
        initView: widget => {
            howspace.annotation.initView(widget);
        },
        destroyView: widget => {
            howspace.annotation.destroyView(widget);
        },
        initEdit: widget => {
            howspace.annotation.initEdit(widget);

            // Image uploaded event.
            widget.on(howspace.components.fileUploader.UPLOAD_COMPLETED, (e) => {
                const uploadedFileId = e.detail.uploadedFiles[0].id;

                real.ajax.html(howspace.widgets.getUrl(widget) + '/image/' + uploadedFileId, {
                    type: 'GET',
                    success: (response) => {
                        const imageCard = widget.find('.image-card .card-content');
                        imageCard.html($(response));
                        howspace.components.init(imageCard);
                    }
                });
            });

            // Rotate image left/right buttons.
            widget.on('click', '.rotate-btn', (e) => {
                const btn = $(e.target);
                const angle = btn.data('angle');
                const picture = widget.find('.howspace-picture');

                if (picture.length === 0) {
                    return;
                }

                let rotateAngle = widget.data('rotate-angle') || 0;
                rotateAngle += angle;

                // Normalize the angle to be within -180 to 180 degrees (required by backend).
                if (rotateAngle < -180) {
                    rotateAngle += 360;
                } else if (rotateAngle > 180) {
                    rotateAngle -= 360;
                }

                if (rotateAngle === 0) {
                    // If the angle is 0, remove the rotation.
                    picture.find('img').css('rotate', '');
                    widget.dataAndAttr('rotate-angle', 0);
                    widget.removeDataAndAttr('is-rotated');
                } else {
                    // Rotate the image using CSS.
                    picture.find('img').css('rotate', `${rotateAngle}deg`);
                    widget.dataAndAttr('rotate-angle', rotateAngle);
                    widget.dataAndAttr('is-rotated', true);
                }
            });

            // Delete image button.
            widget.on('click', '.delete-image-btn', () => {
                // Hide the current image.
                const currentImage = widget.find('.current-image');
                currentImage.velocity('slideUp', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => {
                        currentImage.remove();
                    }
                });

                // Hide the delete container.
                const deleteContainer = widget.find('.delete-image-container');
                deleteContainer.velocity('slideUp', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => {
                        deleteContainer.addClass('d-none');
                    }
                });

                // Show the image uploader.
                const imageUploader = widget.find('.howspace-file-uploader');
                imageUploader.velocity('slideDown', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => [
                        imageUploader.removeClass('d-none')
                    ]
                });

                // Update the form value.
                widget.find('input[name="image_file"]').val('');
            });

            // Image rotated event.
            real.events.on('uploadedfile:stored', (notification) => {
                const metadata = notification.object.uploadedfile.metadata;
                if (!metadata) {
                    return;
                }
                const picture = widget.find('.howspace-picture[data-uploadedfile-id="' + metadata.original_uploaded_file_id + '"]');
                if (picture.length === 0) {
                    return;
                }
                widget.find('input[name="image_file"]').val(notification.object.uploadedfile.id);
                real.button.reset(widget.find('.rotate-btn'));
                howspace.components.picture.replacePicture(
                    picture[0],
                    notification.object.uploadedfile.id,
                    real.baseUri + '/uploadedfile/' + notification.object.uploadedfile.id + '/view',
                    metadata
                );
            });

            // Permanently anonymous checkbox.
            widget.find('.anonymity-checkbox').on('change', e => {
                const checkbox = widget.find('.filter-checkbox');
                if (e.target.checked) {
                    howspace.form.disable(checkbox);
                    checkbox.find('input').prop('checked', false);
                } else {
                    howspace.form.enable(checkbox);
                }
            });

            widget.find('.save-widget-btn').on('click', e => {
                const btn = $(e.target);
                if (!widget.data('is-rotated')) {
                    // If the image is not rotated, just save the widget.
                    return;
                }

                // Image is rotated, let's first save the rotation.
                e.stopImmediatePropagation();
                real.button.loading(btn, widget);

                const token = real.uid();
                const dataPayload = {
                    rotate: widget.find('.howspace-picture').attr('data-uploadedfile-id'),
                    angle: widget.data('rotate-angle'),
                    upload_process_metadata: {token}
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget) + '/uploadedfiles', {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: () => {
                        const handleStored = (notification) => {
                            if (notification.object.uploadedfile?.upload_process_metadata?.token === token) {
                                real.events.off('workspace:uploadedfile:stored', handleStored);
                                widget.find('input[name="image_file"]').val(notification.object.uploadedfile.id);
                                widget.dataAndAttr('is-rotated', false);
                                real.button.reset(btn, widget);
                                btn.trigger('click');
                            }
                        };
                        real.events.on('uploadedfile:stored', handleStored);
                    },
                });
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        initFileUploaderModal: (modal, modalOpener) => {
            const widget = $(modalOpener).closest('.widget');

            modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
                howspace.widgets.image.handleFileUploadCompleted(modal, e.detail.uploadedFiles[0], widget);
            });
        },
        handleFileUploadCompleted: (modal, uploadedFile, widget) => {
            if (widget.data('widget-mode') === 'view') {
                const dataPayload = {
                    image_file: uploadedFile.id
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload)
                });

                howspace.components.modal.close(modal);
            }
        },
        save: (widget, dataPayload) => {
            if (dataPayload.image_link.substring(0, real.baseUri.length) === real.baseUri) {
                // This is an absolute URL inside this workspace.
                // Fix the link to be a relative link instead.
                dataPayload.image_link = dataPayload.image_link.substring(real.baseUri.length);
            }

            dataPayload.pinning_options = [];
            const pinningOptionsWithoutTitle = [];
            widget.find('.option:not(.deleted)').each(function () {
                const optionPayload = real.form.getDataPayload($(this));
                if (optionPayload.title) {
                    dataPayload.pinning_options.push(optionPayload);
                } else {
                    pinningOptionsWithoutTitle.push(optionPayload);
                }
            });

            if (pinningOptionsWithoutTitle.length > 0 && dataPayload.pinning_mode === 'pin') {
                real.notification.show(howspace.translate('common_pinning_option_fill_in_a_title'), 'danger');
                return false;
            }

            return dataPayload;
        },
        updateFilter: (widget) => {
            howspace.annotation.getPins(widget);
        },
        startAnnotating: startAnnotating,
        stopAnnotating: stopAnnotating
    }
})();
